import { render } from "./calculator.vue?vue&type=template&id=f054c514"
import script from "./calculator.vue?vue&type=script&lang=js"
export * from "./calculator.vue?vue&type=script&lang=js"

import "./calculator.vue?vue&type=style&index=0&id=f054c514&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__